// Fallback products using local images until real data is added via admin
export const fallbackProducts = [
  {
    id: 'f1',
    title: 'Claustra Chêne',
    category: 'Claustra',
    description: 'Séparation de pièce en bois de chêne massif, design moderne et fonctionnel. Idéal pour structurer les espaces tout en conservant la luminosité. Fabriqué sur mesure avec des finitions premium.',
    image_url: '/images/catalogue/claustra-chene.jpg',
    gallery: []
  },
  {
    id: 'f2',
    title: 'Porte Garofoli',
    category: 'Portes',
    description: 'Porte intérieure en bois naturel avec panneau central rainuré, finition élégante et sobre. Un grand classique indémodable qui s\'adapte à tous les intérieurs modernes avec une isolation phonique renforcée.',
    image_url: '/images/catalogue/porte-garofoli.jpg',
    gallery: []
  },
  {
    id: 'f3',
    title: 'Habillage Mural LED',
    category: 'Habillage Mural',
    description: 'Habillage mural en bois composite avec miroir rond intégré et rétro-éclairage LED ambiant. Parfait pour sublimer un hall d\'entrée ou une chambre à coucher avec une atmosphère chaleureuse.',
    image_url: '/images/catalogue/habillage-mural-led.jpg',
    gallery: []
  },
  {
    id: 'f4',
    title: 'Dressing Sur Mesure',
    category: 'Placards & Dressings',
    description: 'Dressing blanc laqué avec colonne d\'étagères en chêne massif, design épuré et fonctionnel. Profitez d\'un espace de rangement optimisé pour vos vêtements grâce à ses compartiments intelligents.',
    image_url: '/images/catalogue/dressing-sur-mesure.jpg',
    gallery: []
  },
  {
    id: 'f5',
    title: 'Porte Intérieure Classique',
    category: 'Portes',
    description: 'Porte intérieure en bois clair, poignée noire mate, style minimaliste et intemporel. Sa structure robuste garantit stabilité et longévité, tout en diffusant une atmosphère accueillante.',
    image_url: '/images/catalogue/porte-classique.jpg',
    gallery: []
  },
  {
    id: 'f6',
    title: 'Porte Noyer Premium',
    category: 'Portes',
    description: 'Porte en noyer massif avec veinage apparent, design contemporain et poignée noire de haute qualité. Le choix parfait pour un intérieur luxueux et raffiné.',
    image_url: '/images/catalogue/telecharger-1.jpg',
    gallery: []
  },
  {
    id: 'f7',
    title: 'Porte Chêne Naturel',
    category: 'Portes',
    description: 'Porte en chêne massif avec finition naturelle, poignée chromée et cadre contrasté. Un mariage subtil entre tradition et modernité.',
    image_url: '/images/catalogue/telecharger-2.jpg',
    gallery: []
  },
  {
    id: 'f8',
    title: 'Porte Deux Tons',
    category: 'Portes',
    description: 'Porte bi-ton avec panneau central contrasté et poignée noire mate, style moderne audacieux. Parfait pour donner du caractère à vos espaces de vie.',
    image_url: '/images/catalogue/telecharger-3.jpg',
    gallery: []
  },
  {
    id: 'f9',
    title: 'Placard Coulissant',
    category: 'Placards & Dressings',
    description: 'Placard coulissant en bois massif avec étagères intégrées et rangement optimisé. Ses portes fluides et silencieuses offrent un confort d\'utilisation quotidien maximal.',
    image_url: '/images/catalogue/telecharger-4.jpg',
    gallery: []
  },
  {
    id: 'f10',
    title: 'Console Miroir Tasseaux',
    category: 'Habillage Mural',
    description: 'Console murale flottante avec habillage en tasseaux de bois et miroir ovale intégré, idéale pour les halls et couloirs avec un look architectural distinct.',
    image_url: '/images/catalogue/telecharger-5.jpg',
    gallery: []
  },
];
